export default {
  postUrl() {
    return 'https://fakestoreapi.com/products'
  },
  putUrl() {
    return 'https://fakestoreapi.com/products/1'
  },
  getUrl() {
    return 'https://fakestoreapi.com/products'
  },
  deleteUrl() {
    return 'https://fakestoreapi.com/products/1'
  },

  parse(raw = {}) {
    return {
      statusCode: raw?.statusCode || 200,
      message: raw?.message || 'Message sent successfully',
      data: raw?.data || null,
    }
  },

  format(payload = {}) {
    return {
      message: {
        id: payload.id || null,
        senderId: payload.senderId,
        senderName: payload.senderName,
        senderRole: payload.senderRole || 'support',
        recipientId: payload.recipientId,
        recipientName: payload.recipientName,
        recipientRole: payload.recipientRole || 'rider',
        content: payload.message,
        orderId: payload.orderId || null,
        attachments: payload.attachments || [],
        type: payload.type || 'text', // text, photo, location, system
        priority: payload.priority || 'normal',
        metadata: payload.metadata || {},
      },
      delivery: {
        channels: payload.channels || ['in_app', 'push'],
        requireReceipt: payload.requireReceipt !== false,
        expiresAt: payload.expiresAt || null,
      },
      context: {
        conversationId: payload.conversationId || null,
        replyToMessageId: payload.replyToMessageId || null,
        isSupportRequest: payload.isSupportRequest || false,
        isEmergency: payload.isEmergency || false,
      },
    }
  },
}
